export default __webpack_public_path__ + "static/media/icon-taks-action.94f739eb.svg";